// extracted by mini-css-extract-plugin
export default {"badge":"StatusBadge_badge__zQfta"};